import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { NzNotificationService } from 'ng-zorro-antd/notification';

import * as SubscriptionsActions from './subscriptions.actions';
import { APIService } from '../../services/api/api-service';

@Injectable()
export class SubscriptionEffects {
  constructor(
    private actions$: Actions,
    private notification: NzNotificationService,
    private api: APIService
  ) {}

  loadAllSubscriptions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SubscriptionsActions.getSubscriptions),
      switchMap(action =>
        this.api.getSubscriptions().pipe(
          map(subscriptions =>
            SubscriptionsActions.getSubscriptionsSuccess({
              subscriptions
            })
          ),
          catchError(error => {
            console.error('Error', error);
            this.notification.error(
              'Subscriptions',
              error?.error?.message || 'Failed to load'
            );
            return of(SubscriptionsActions.getSubscriptionsFailure({ error }));
          })
        )
      )
    )
  );

  loadSubscription$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SubscriptionsActions.getSubscription),
      switchMap(action =>
        this.api.getSubscription(action.id).pipe(
          map(subscription =>
            SubscriptionsActions.getSubscriptionSuccess({
              subscription
            })
          ),
          catchError(error => {
            console.error('Error', error);
            this.notification.error(
              'Subscription',
              error?.error?.message || 'Failed to load'
            );
            return of(SubscriptionsActions.getSubscriptionFailure({ error }));
          })
        )
      )
    )
  );

  updateSubscription$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SubscriptionsActions.updateSubscription),
      switchMap(action =>
        this.api.updateSubscription(action.id, action.updates).pipe(
          map(subscription =>
            SubscriptionsActions.updateSubscriptionSuccess({
              subscription
            })
          ),
          catchError(error => {
            console.error('Error', error);
            this.notification.error(
              'Subscription',
              error?.error?.message || 'Failed to update subscription'
            );
            return of(SubscriptionsActions.updateSubscriptionFailure({ error }));
          })
        )
      )
    )
  );
}
